/**
 * phoneCountries.js — shared country dial-prefix list for the phone inputs on
 * the register page and the invited-employee accept page (/join). Keeping it in
 * one place means both forms offer the same prefixes.
 */
export const countries = [
  { name: 'Spain', code: 'ES', prefix: '+34', flag: '🇪🇸' },
  { name: 'France', code: 'FR', prefix: '+33', flag: '🇫🇷' },
  { name: 'USA', code: 'US', prefix: '+1', flag: '🇺🇸' },
  { name: 'UK', code: 'GB', prefix: '+44', flag: '🇬🇧' },
  { name: 'Ireland', code: 'IE', prefix: '+353', flag: '🇮🇪' },
  { name: 'Germany', code: 'DE', prefix: '+49', flag: '🇩🇪' },
  { name: 'Italy', code: 'IT', prefix: '+39', flag: '🇮🇹' },
  { name: 'Portugal', code: 'PT', prefix: '+351', flag: '🇵🇹' },
  { name: 'Netherlands', code: 'NL', prefix: '+31', flag: '🇳🇱' },
  { name: 'Belgium', code: 'BE', prefix: '+32', flag: '🇧🇪' },
  { name: 'Switzerland', code: 'CH', prefix: '+41', flag: '🇨🇭' },
  { name: 'Sweden', code: 'SE', prefix: '+46', flag: '🇸🇪' },
  { name: 'Norway', code: 'NO', prefix: '+47', flag: '🇳🇴' },
  { name: 'Denmark', code: 'DK', prefix: '+45', flag: '🇩🇰' },
  { name: 'Poland', code: 'PL', prefix: '+48', flag: '🇵🇱' },
  { name: 'Mexico', code: 'MX', prefix: '+52', flag: '🇲🇽' },
  { name: 'Argentina', code: 'AR', prefix: '+54', flag: '🇦🇷' },
  { name: 'Brazil', code: 'BR', prefix: '+55', flag: '🇧🇷' },
  { name: 'Chile', code: 'CL', prefix: '+56', flag: '🇨🇱' },
  { name: 'Colombia', code: 'CO', prefix: '+57', flag: '🇨🇴' },
  { name: 'Venezuela', code: 'VE', prefix: '+58', flag: '🇻🇪' },
  { name: 'Peru', code: 'PE', prefix: '+51', flag: '🇵🇪' },
  { name: 'Japan', code: 'JP', prefix: '+81', flag: '🇯🇵' },
  { name: 'China', code: 'CN', prefix: '+86', flag: '🇨🇳' },
  { name: 'Korea', code: 'KR', prefix: '+82', flag: '🇰🇷' },
  { name: 'India', code: 'IN', prefix: '+91', flag: '🇮🇳' },
  { name: 'Australia', code: 'AU', prefix: '+61', flag: '🇦🇺' },
  { name: 'New Zealand', code: 'NZ', prefix: '+64', flag: '🇳🇿' },
  { name: 'Russia', code: 'RU', prefix: '+7', flag: '🇷🇺' },
  { name: 'Turkey', code: 'TR', prefix: '+90', flag: '🇹🇷' },
];
